import React from 'react';
import { Toast } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import '../style/style.css';
import PropTypes from 'prop-types';

export default function SuccessMessage({ show, setShow, message }) {
  return (
    <div className="toast-container pb-5 pe-md-5 pe-2">
      <Toast onClose={() => setShow(false)} show={show} delay={6000} autohide>
        <Toast.Header closeButton={false}>
          <FaCheckCircle style={{ color: 'green' }} />
          <strong className="me-auto ps-2" style={{ color: 'green' }}>
            Notificação
          </strong>
          <small>agora mesmo</small>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </div>
  );
}

SuccessMessage.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};
